<template>
  <div id="build-nav">
    <v-toolbar flat fixed>
      <v-btn icon @click="drawer = !drawer" class="hidden-md-and-up">
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar-title>
        <router-link :to="{ name: 'Home'}">
          <img @click="$emit('startOver')" class="builder-logo" src="../../static/images/Dealer-Draft_logo.png">
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="build-controls hidden-sm-and-down">
        <router-link :to="{ name: 'SRPBuilder'}">
          <v-btn @click="$emit('startOver')" flat>Start Over</v-btn>
        </router-link>
        <v-btn dark icon large class="camera-btn" @click="shoot">
          <v-icon>photo_camera</v-icon>
        </v-btn>
        <router-link v-if="brand.toLowerCase() !== 'mazda'" :to="{ name: 'SRPBuilder', params: { refine: true } }">
          <v-btn flat>Back</v-btn>
        </router-link>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down extra-padding">
        <router-link :to="{ name: 'Home' }">
          <v-btn @click="$emit('startOver')" flat>Home</v-btn>
        </router-link>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list>
        <v-list-tile to="/builder">
          <v-list-tile-title>Home Build</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/srp-builder">
          <v-list-tile-title>SRP Build</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'SRPPreviewNavbar',
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      drawer: false,
    }
  },
  methods: {
    goToPreview() {
      this.$router.push({ name: 'SRPPreview' })
    },
    shoot() {
      this.$html2canvas(document.querySelector("#preview")).then(function(
        canvas
      ) {
        canvas.toBlob(function(blob) {
          saveAs(blob, "srp.png");
        });
      });
    }
  },
  computed: {
    ...mapState(['chosenBrand']),
  },
}
</script>

<style scoped>
  #build-nav {
    height: 64px;
  }
  .builder-logo {
    max-height: 40px;
  }
  .v-toolbar--fixed {
    z-index: 10;
  }
  .build-controls {
    justify-content: space-between;
    min-width: 420px;
  }
  .extra-padding {
    padding-left: 70px;
  }
  .camera-btn {
    background-color: #006aff;
  }
  .mobile-nav {
    width: 250px;
  }
  @media (max-width: 959px) {
    .v-navigation-drawer--temporary, 
    .v-navigation-drawer--is-mobile {
      z-index: 99999999;
    }
  }
</style>